//Divi Akkordeon standardmäßig schließen + schließen geöffneter Akkordions

jQuery(function($){

  $('.et_pb_accordion .et_pb_toggle').each(function(){

    var $toggle    = $(this);
    var $accordion = $toggle.closest('.et_pb_accordion');
    var $content   = $toggle.find('.et_pb_toggle_content');

    // Ausgangszustand: alles zu
    $toggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close');
    $content.each(function(){
      this.style.height = '0px';
    });

    // Divi-Standard-Klick entfernen
    $toggle.off('click');

    // Unser eigenes Toggle-Verhalten
    $toggle.on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var $this    = $(this);
      var content  = $this.find('.et_pb_toggle_content')[0];

      // Helper: Höhe nach Animation wieder auf "auto" setzen, wenn offen
      var setHeightAuto = function(ev) {
        if (ev.propertyName !== 'height') return;
        content.removeEventListener('transitionend', setHeightAuto);
        if ($this.hasClass('et_pb_toggle_open')) {
          content.style.height = 'auto';
        }
      };

      // Wenn bereits offen → schließen
      if ($this.hasClass('et_pb_toggle_open')) {

        // aktuelle Höhe holen (kann "auto" sein)
        var startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        // Reflow erzwingen
        content.offsetHeight;
        // auf 0 animieren
        content.style.height = '0px';

        $this
          .removeClass('et_pb_toggle_open')
          .addClass('et_pb_toggle_close');

      } else {

        // andere Einträge schließen (klassisches Akkordeon)
        $accordion.find('.et_pb_toggle_open').each(function(){
          var $other   = $(this);
          var otherEl  = $other.find('.et_pb_toggle_content')[0];

          if (!otherEl) return;

          var otherHeight = otherEl.scrollHeight;
          otherEl.style.height = otherHeight + 'px';
          otherEl.offsetHeight;
          otherEl.style.height = '0px';

          $other
            .removeClass('et_pb_toggle_open')
            .addClass('et_pb_toggle_close');
        });

        // diesen Eintrag öffnen
        $this
          .removeClass('et_pb_toggle_close')
          .addClass('et_pb_toggle_open');

        // von 0 auf tatsächliche Höhe animieren
        content.style.height = '0px';            // Startpunkt
        content.offsetHeight;                    // Reflow
        content.style.height = content.scrollHeight + 'px';

        // nach der Animation auf "auto" stellen
        content.addEventListener('transitionend', setHeightAuto);
      }
    });

  });

});

//Pricing

(function($){

  /**
   * Setzt für eine Gruppe von Elementen die min-height
   * auf die jeweils größte Höhe (wie dein altes Script).
   */
  function setMinHeight($items){
    var max = 0;

    // Erst alles zurücksetzen, damit wir die natürliche Höhe messen
    $items.css('min-height','');

    $items.each(function(){
      var h = $(this).outerHeight();
      if (h > max) {
        max = h;
      }
    });

    if (max > 0) {
      $items.css('min-height', max + 'px');
    } else {
      $items.css('min-height','');
    }
  }

  /**
   * Sucht in mehreren Spalten (Cards) jeweils das i-te Element
   * eines bestimmten Selektors und equalized diese Gruppe.
   */
  function matchByIndex($cols, selector){
    var maxCount = 0;

    $cols.each(function(){
      maxCount = Math.max(maxCount, $(this).find(selector).length);
    });

    for (var i = 0; i < maxCount; i++){
      var group = [];
      $cols.each(function(){
        var $el = $(this).find(selector).eq(i);
        if ($el.length) group.push($el[0]);
      });
      if (group.length > 1) {
        setMinHeight($(group));
      }
    }
  }

  /**
   * Setzt ALLE min-height der Pricing-Elemente zurück.
   */
  function reset(){
    $('.pricing-card .m-title, ' +
      '.pricing-card .m-desc, ' +
      '.pricing-card .m-price, ' +
      '.pricing-card .m-features, ' +
      '.pricing-card .m-cta-text, ' +
      '.pricing-card .m-cta-btn, ' +
      '.pricing-card .m-info'
    ).css('min-height','');
  }

  /**
   * Hilfsfunktion:
   * Wenn eine Row versteckt ist (display:none), wird sie
   * kurz "unsichtbar sichtbar" gemacht, damit wir darin
   * sauber messen können – ohne dass der Nutzer etwas sieht.
   */
  function withRowTemporarilyShown($row, callback){
    var wasVisible = $row.is(':visible');

    // Wenn die Row sowieso sichtbar ist → ganz normal
    if (wasVisible) {
      callback();
      return;
    }

    // Original inline-style merken
    var originalStyle = $row.attr('style');

    // Row kurz aus dem Layout rausziehen & unsichtbar machen
    $row.css({
      display: 'block',
      position: 'absolute',
      visibility: 'hidden',
      left: '-9999px',
      top: '-9999px'
    });

    callback();

    // Ursprünglichen inline-style wiederherstellen
    if (typeof originalStyle === 'string') {
      $row.attr('style', originalStyle);
    } else {
      $row.removeAttr('style');
    }
  }

  function run(){
    var w = window.innerWidth || document.documentElement.clientWidth;

    // Unter / gleich 980px: keine Equal Heights, alles zurücksetzen
    if (w <= 980){
      reset();
      return;
    }

    // Desktop: zuerst alle min-heights entfernen
    reset();

    // Jede Row separat, ABER auch versteckte vorbereiten
    $('.pricing-row-1, .pricing-row-2').each(function(){

      var $row = $(this);

      withRowTemporarilyShown($row, function(){

        var $cols = $row.find('.pricing-card');
        if (!$cols.length) return;

        matchByIndex($cols, '.m-title');
        matchByIndex($cols, '.m-desc');
        matchByIndex($cols, '.m-price');
        matchByIndex($cols, '.m-features');
        matchByIndex($cols, '.m-cta-text');
        matchByIndex($cols, '.m-cta-btn');
        matchByIndex($cols, '.m-info');

      });

    });
  }

  /**
   * Debounced Wrapper, z.B. für window.resize
   */
  function debounced(){
    clearTimeout(window.__mh);
    window.__mh = setTimeout(run, 120);
  }

  // nach außen verfügbar machen, falls du es von Divi/Inline Script aufrufst
  window.matchHeightsRun = run;
  window.matchHeightsDebounced = debounced;

  // Typischerweise:
  $(window).on('load resize', debounced);

})(jQuery);



//Scroll-Animation NAV

document.addEventListener('DOMContentLoaded', function () {
  const body    = document.body;
  const logoImg = document.querySelector('.site-header_logo img');

  if (!logoImg) return;

  const defaultLogo = logoImg.getAttribute('data-logo-default');
  const smallLogo   = logoImg.getAttribute('data-logo-small');

  const threshold = 80; // ab welchem Scroll-Pixel die Änderung greift

  window.addEventListener('scroll', function () {
    if (window.scrollY > threshold) {
      // Zustand: gescrollt
      body.classList.add('header-scrolled');
      if (smallLogo) logoImg.src = smallLogo;
    } else {
      // Zustand: wieder oben
      body.classList.remove('header-scrolled');
      if (defaultLogo) logoImg.src = defaultLogo;
    }
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const body    = document.body;
//   const logoImg = document.querySelector('.site-header_logo img');

//   if (!logoImg) return;

//   const defaultLogo = logoImg.getAttribute('data-logo-default');
//   const smallLogo   = logoImg.getAttribute('data-logo-small');

//   let lastScrollY = window.scrollY;
//   const delta = 50;
//   const topLock = 80; 

//   window.addEventListener('scroll', function () {
//     const currentScrollY = window.scrollY;

//     if (currentScrollY < topLock) {
//       body.classList.remove('header-scrolled');
//       if (defaultLogo) logoImg.src = defaultLogo;
//       lastScrollY = currentScrollY; 
//       return;
//     }

//     const difference = currentScrollY - lastScrollY;

//     if (Math.abs(difference) > delta) {
//       const isScrollingUp = difference < 0;

//       if (isScrollingUp) {
//         body.classList.remove('header-scrolled');
//         if (defaultLogo) logoImg.src = defaultLogo;
//       } else {
//         body.classList.add('header-scrolled');
//         if (smallLogo) logoImg.src = smallLogo;
//       }

//       lastScrollY = currentScrollY;
//     }
//   });
// });


//Button Umschaltung Angebote

document.addEventListener('DOMContentLoaded', function () {
  const switchContainer = document.querySelector('.angebot-switch');
  const options = document.querySelectorAll('.switch-option');
  const slider = document.querySelector('.switch-slider');

  const set1 = document.querySelector('#angebote-set-1');
  const set2 = document.querySelector('#angebote-set-2');

  if (!set1 || !set2 || !switchContainer || options.length === 0) {
    return; // Sicherheits-Check
  }

  // Anfangszustand
  set1.style.display = 'flex';
  set2.style.display = 'none';

  // nach dem initialen Anzeigen von Set 1 einmal Höhen berechnen
  if (typeof window.pricingEqualize === 'function') {
    window.pricingEqualize();
  }

  options.forEach((opt, index) => {
    opt.addEventListener('click', function () {

      // Visueller Toggle: active-Klasse
      options.forEach(o => o.classList.remove('active'));
      this.classList.add('active');

      if (index === 0) {
        // Schalter-Optik
        switchContainer.classList.remove('right-active');

        // Sets umschalten
        set1.style.display = 'flex';
        set2.style.display = 'none';
      } else {
        switchContainer.classList.add('right-active');

        set1.style.display = 'none';
        set2.style.display = 'flex';
      }

        //nach jedem Umschalten neu equalizen
      if (typeof window.pricingEqualize === 'function') {
        window.pricingEqualize();
      }
    });
  });
});

// Wenn info-area aktiv, wird margin-top von faq-icon auf 0px gesetzt

document.addEventListener('DOMContentLoaded', function () {

    const infoArea = document.querySelector('.info-area');
    const faqIcon  = document.querySelector('.faq-icon');

    if (infoArea && faqIcon) {
        faqIcon.style.setProperty('margin-top', '0px', 'important');
    }
});

// Video Modul erst anzeigen nachdem DOM geladen ist


document.addEventListener("DOMContentLoaded", function () {
  // nächster Paint, damit CSS sicher sitzt
  requestAnimationFrame(function(){
    document.body.classList.add("divi-video-ready");
  });
});